function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkraineKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 352.8 104.3",
    style: {
      enableBackground: "new 0 0 342.8 94.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 61.2,
    cy: 69.519,
    r: 51.712,
    gradientTransform: "matrix(1 0 0 -1 0 97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    style: {
      stopColor: "#e6f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    style: {
      stopColor: "#9acfc9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    style: {
      stopColor: "#48aa9d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    style: {
      stopColor: "#149281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    style: {
      stopColor: "#008976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006351"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.9 47.7C86.8 70 68.7 88 46.4 87.9S6.1 69.6 6.2 47.3 24.4 7 46.7 7.1 87 25.4 86.9 47.7z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 227.393,
    cy: 68.855,
    r: 51.712,
    gradientTransform: "matrix(1 0 0 -1 0 97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    style: {
      stopColor: "#e6f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    style: {
      stopColor: "#9acfc9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    style: {
      stopColor: "#48aa9d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    style: {
      stopColor: "#149281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    style: {
      stopColor: "#008976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006351"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.1 48.3c-.1 22.3-18.2 40.3-40.5 40.2S172.3 70.3 172.4 48s18.2-40.3 40.5-40.2c22.3.1 40.3 18.2 40.2 40.5z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 146.55,
    cy: 72.196,
    r: 51.616,
    gradientTransform: "matrix(1 0 0 -1 0 97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    style: {
      stopColor: "#f6e2dd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#f2bfb2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    style: {
      stopColor: "#ed957f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e97457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#e65d3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#e54e28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    style: {
      stopColor: "#e44922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b13c24"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170 48c-.1 22.3-18.2 40.3-40.5 40.2-22.3-.1-40.3-18.2-40.2-40.5s18.2-40.3 40.5-40.2c22.3 0 40.3 18.2 40.2 40.5z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 312.739,
    cy: 72.532,
    r: 51.611,
    gradientTransform: "matrix(1 0 0 -1 0 97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    style: {
      stopColor: "#f6e2dd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#f2bfb2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    style: {
      stopColor: "#ed957f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e97457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#e65d3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#e54e28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    style: {
      stopColor: "#e44922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b13c24"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 47.7C336.1 70 318 88 295.7 87.9s-40.3-18.2-40.2-40.5S273.7 7.1 296 7.2c22.3 0 40.3 18.2 40.2 40.5z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -3408.466,
    cy: 3838.618,
    r: 89.49,
    gradientTransform: "matrix(.6982 0 0 -.6982 2442.804 2708.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#f9f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#e8e9eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#ccced2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a6a9b0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.8 66.7c-1 .2-2.1.1-3.1.1-6.6-.4-7.2-2.7-10.3-8.2-1.5-2.6-6.5-10.7-10.1-10.9-5.7-.3-4.1 8.5-4.3 12.3-.2 3.3-.3 5.4-4.8 5.1-1.8-.1-4.1-.5-4-2.9 0 0-1.1-10.7-.4-20.3s4.9-21.2 4.9-21.2c.1-2 2.7-2.6 4.3-2.5 4 .2 4.3 1.8 4.3 6.5-.1 3.9-3.1 10.5 2.4 10.8 4 .2 8.8-7.4 10.9-9.8 3.3-3.9 4.1-5.7 9.7-5.4.8 0 3 .2 3.6.8-.2 3-14.7 14.5-15.1 21-.3 6.4 11.3 17.3 13.2 23.8-.3.4-.7.7-1.2.8z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -3290.597,
    cy: 3841.724,
    r: 96.76,
    gradientTransform: "matrix(.6982 0 0 -.6982 2442.804 2708.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#f9f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#e8e9eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#ccced2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a6a9b0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.6 68.5c-2.7.5-5.8.2-7.5-.1-15.5-2.4-21.6-16-19.6-29 2.1-13.2 12.6-23.1 27.2-20.8 3.2.5 11.4 2.7 10.7 7.2-.2 1.5-.9 1.8-1.7 1.7-2.7-.4-5.2-2.1-8-2.5-5.6-.9-14.5.1-15.7 7.8-1.5 9.6 13.4 6.1 12.7 10.4-.8 4.9-15-3.8-16.6 6.3-1.1 7.1 7 12.2 13.1 13.2 2.9.5 6-.3 9 .2.9.1 1.3.6 1.1 1.9-.4 2.1-2 3.3-4.7 3.7z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -3172.056,
    cy: 3841.633,
    r: 95.153,
    gradientTransform: "matrix(.6982 0 0 -.6982 2442.804 2708.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#f9f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#e8e9eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#ccced2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a6a9b0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.6 73.9c0 .1 0 .2-.1.3 0 .1 0 .2-.1.3-.5.7-1 1.1-1.5 1.3-.5.2-1.1.3-1.8.4-1.1.1-2.2.1-3.1-.3-.8-.4-1.4-1.1-1.5-2.2l-.6-4.8-.6-4.8c-.4-3.4-2.1-5.2-4.4-6.1-2.3-.9-5-.8-7.4-.5-2.3.3-5 1-7 2.4s-3.3 3.5-3 6.7l.6 4.8.6 4.8c.2 1.2-.3 2-1.1 2.6s-1.8.8-2.7.9c-.6.1-1.6.2-2.4 0-.8-.1-1.6-.5-1.7-1.5 0 0-3-11.6-4.1-19.7-1.1-8.2-.8-21.4-.8-21.4-.1-.8.6-1.3 1.4-1.7.8-.4 1.8-.6 2.3-.7 1.2-.1 2.3-.1 3.1.3.8.4 1.4 1.1 1.5 2.2l.5 3.8.5 3.8c.4 3.1 2.2 4.8 4.5 5.7s5.1 1 7.3.7c2.4-.3 5-.9 7-2.3s3.3-3.5 2.9-6.7l-.4-3.8-.5-3.8c-.1-1.2.2-2 1-2.6.7-.6 1.7-.9 2.9-1 .5-.1 1.5-.1 2.4.1s1.7.6 1.7 1.3c0 0 2.4 10.7 3.4 20s1.4 20.6 1.4 20.6v.4c-.1.2-.1.4-.2.5z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 314.462,
    cy: 66.433,
    r: 68.301,
    gradientTransform: "matrix(1 0 0 -1 0 97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#f9f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#e8e9eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#ccced2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a6a9b0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.4 68c-14 3.3-25.8-4.1-29-17.5-3.3-14 4.8-25.6 18-28.7 14-3.3 25.8 4.1 29 17.5 3.4 14-4.7 25.5-18 28.7m-9.5-39.8c-8.9 2.1-12.7 11.3-10.5 20.2 1.5 6.2 7.4 15.8 18.5 13.2 10.4-2.5 12.2-13.1 10.6-20.1-1.5-6.2-7.5-15.9-18.6-13.3z",
    style: {
      fill: "url(#h)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraineKeno);
export default __webpack_public_path__ + "static/media/ukraine_keno.82b463b336c664ec168e11722994b9be.svg";
export { ForwardRef as ReactComponent };